import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

type ThumbnailModalProps = {
    isOpen: boolean;
    onClose: () => void;
    filename: string;
    imgUrl: string;
    fullScale: boolean;
};

function CloseButton({ onClose }: { onClose: () => void }) {
    return (
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500]
            }}
        >
            <CloseIcon />
        </IconButton>
    );
}

export function ThumbnailModal({
    isOpen,
    imgUrl,
    onClose,
    filename,
    fullScale
}: ThumbnailModalProps) {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth={false}>
            <DialogTitle>{filename}</DialogTitle>
            <CloseButton onClose={onClose} />
            <DialogContent
                sx={
                    fullScale
                        ? {
                              p: 0,
                              overflow: 'auto',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              background: '#000'
                          }
                        : undefined
                }
            >
                <img
                    style={
                        fullScale
                            ? {
                                  maxWidth: '80vw',
                                  maxHeight: '80vh',
                                  width: 'auto',
                                  height: 'auto',
                                  objectFit: 'contain',
                                  display: 'block'
                              }
                            : undefined
                    }
                    src={imgUrl}
                    alt="Digital styling image"
                />
            </DialogContent>
        </Dialog>
    );
}
